import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AuthGuardFxn } from './core/guards/auth.guard';
// multitenant to single tenant
// import { RouteVerificationComponent } from './open links/route-verification/route-verification.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    canActivate: [AuthGuardFxn],
    component: AuthComponent,
    loadChildren: () => import('./pages/auth/auth-route').then(m => m.routes)
  },
  {
    // Serves both School Manager account activation AND Tutor/Counsellor/
    // Parent activation (School Manager import flow) on the same page/link
    // shape — the backend's invitation email appends `&type=instructor` to
    // distinguish the latter (see SetPasswordComponent, which reads it from
    // the query string, not route data, since both flows share this path).
    path: 'set-password',
    component: AuthComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/auth/set-password/set-password.component').then(
          (m) => m.SetPasswordComponent
        )
      }
    ]
  },
  {
    path: 'parent-consent',
    component: AuthComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/auth/parent-consent/parent-consent.component').then(
          (m) => m.ParentConsentComponent
        )
      }
    ]
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuardFxn],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/after-login-page/pages-route').then((m) => m.routes)
      }
    ]
  }
  // multitenant to single tenant
  // {
  //   path: 'noTenant',
  //   component: RouteVerificationComponent
  // }
];

RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'enabled'
});
